(function () {
  var TZ = 'America/Los_Angeles';

  function parsePacificDateTime(iso) {
    if (!iso || !iso.trim()) return null;

    var match = iso.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/);
    if (!match) return null;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var hour = Number(match[4]);
    var minute = Number(match[5]);
    var second = Number(match[6]);
    var guess = Date.UTC(year, month - 1, day, hour + 8, minute, second);

    for (var i = 0; i < 5; i++) {
      var formatted = new Intl.DateTimeFormat('en-CA', {
        timeZone: TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).format(new Date(guess));

      var target =
        String(year).padStart(4, '0') +
        '-' +
        String(month).padStart(2, '0') +
        '-' +
        String(day).padStart(2, '0') +
        'T' +
        String(hour).padStart(2, '0') +
        ':' +
        String(minute).padStart(2, '0') +
        ':' +
        String(second).padStart(2, '0');

      if (formatted === target) return guess;

      var parts = formatted.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/);
      if (!parts) return guess;

      var diffMs =
        Date.UTC(year, month - 1, day, hour, minute, second) -
        Date.UTC(
          Number(parts[1]),
          Number(parts[2]) - 1,
          Number(parts[3]),
          Number(parts[4]),
          Number(parts[5]),
          Number(parts[6])
        );

      guess += diffMs;
    }

    return guess;
  }

  function isWithinSchedule(startStr, endStr) {
    var now = Date.now();
    var start = parsePacificDateTime(startStr);
    var end = parsePacificDateTime(endStr);

    if (start != null && now < start) return false;
    if (end != null && now > end) return false;
    return true;
  }

  function isAnnouncementVisible(el) {
    return !el.classList.contains('announcement--schedule-controlled') || el.classList.contains('is-schedule-visible');
  }

  function refreshSlideshows() {
    document.querySelectorAll('slideshow-component.announcement-bar').forEach(function (slideshow) {
      var visibleSlides = Array.from(slideshow.sliderItems || []).filter(function (slide) {
        return slide.clientWidth > 0;
      });

      var sliderWrapper = slideshow.querySelector('.announcement-bar-slider');
      var singleVisible = visibleSlides.length <= 1;

      if (sliderWrapper) {
        sliderWrapper.classList.toggle('announcement-bar-slider--no-controls', singleVisible);
        sliderWrapper.classList.toggle('announcement-bar-slider--single', singleVisible);
      }

      if (!slideshow.slider || visibleSlides.length === 0) return;

      slideshow.slider.scrollLeft = singleVisible ? 0 : visibleSlides[0].offsetLeft;
      slideshow.sliderFirstItemNode = visibleSlides[0];

      if (typeof slideshow.resetPages === 'function') {
        slideshow.resetPages();
      }

      if (typeof slideshow.setSlideVisibility === 'function') {
        slideshow.setSlideVisibility();
      }

      if (visibleSlides.length <= 1) {
        if (typeof slideshow.pause === 'function') slideshow.pause();
        return;
      }

      if (
        slideshow.slider.getAttribute('data-autoplay') === 'true' &&
        typeof slideshow.play === 'function' &&
        (!slideshow.reducedMotion || !slideshow.reducedMotion.matches) &&
        !slideshow.announcementBarArrowButtonWasClicked
      ) {
        slideshow.play();
      }
    });
  }

  function init() {
    document.querySelectorAll('.announcement--schedule-controlled').forEach(function (el) {
      el.classList.toggle('is-schedule-visible', isWithinSchedule(el.dataset.scheduleStart, el.dataset.scheduleEnd));
    });

    document.querySelectorAll('.announcement-bar-section').forEach(function (section) {
      var announcements = section.querySelectorAll('.utility-bar__grid > .announcement-bar, .utility-bar__grid .slideshow__slide');
      var visibleCount = 0;

      announcements.forEach(function (el) {
        if (isAnnouncementVisible(el)) visibleCount++;
      });

      var hideBar = announcements.length > 0 && visibleCount === 0;
      section.style.display = hideBar ? 'none' : '';

      section.querySelectorAll('.announcement-bar, slideshow-component.announcement-bar').forEach(function (bar) {
        bar.style.display = hideBar ? 'none' : '';
      });
    });

    refreshSlideshows();
  }

  init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('shopify:block:select', init);
})();
